import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SOLUTION_SUB_ROUTES } from '../../constant';

import SolutionRouteContainer from './SolutionRoute.container';

const SolutionRoute = () => {
  return (
    <SolutionRouteContainer>
      {({ variant, solutionData }) => {
        return (
          <Switch>
            {Object.keys(SOLUTION_SUB_ROUTES).map((key) => {
              const route = SOLUTION_SUB_ROUTES[key];
              const { exact, path, component: Component } = route;
              return (
                <Route
                  key={path}
                  exact={exact}
                  path={path}
                  render={(props) => (
                    <Component variant={variant} solutionData={solutionData} {...props} />
                  )}
                />
              );
            })}
          </Switch>
        );
      }}
    </SolutionRouteContainer>
  );
};

export default SolutionRoute;
